import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import { TOrderPaymentInformationPayload } from "@zeal/common";
import { TValidateOrderPaymentShareableLinkTokenRequest } from "./validateOrderPaymentShareableLinkToken.schema";

export const validateOrderPaymentShareableLinkToken = (
  axios: IAxiosInstance
) => {
  return async (params: TValidateOrderPaymentShareableLinkTokenRequest) => {
    const response = await axios.noRetry.post<
      IApiResponse<TOrderPaymentInformationPayload>
    >("/api/validateOrderPaymentShareableLinkToken", params);
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
